import useAuthStore from '@/stores/useAuthStore'
import { paths } from '@/utils/path'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'

const AuthLayout = () => {
    const { employee } = useAuthStore()
    const [searchParams] = useSearchParams()

    if (employee) {
        return <Navigate to={searchParams?.get('redirect') || paths.home} />
    }

    return (
        <div className="min-h-svh relative bg-white overflow-hidden">
            {/* Background Image - Full Screen */}
            <div className="absolute inset-0">
                <img
                    className="w-full h-full object-cover"
                    src="/images/vector-1748360867010-ae8dad26ca0f.png"
                    alt="Login background"
                />
                {/* Optional overlay for better contrast on mobile and tablet */}
                <div className="absolute inset-0 bg-black/10 lg:bg-transparent"></div>
            </div>

            {/* Login Form Container - Responsive */}
            <div className="relative z-10 min-h-svh flex items-center justify-center">
                <div className="w-full lg:ml-12 xl:ml-16 2xl:ml-20 max-w-sm sm:max-w-md md:max-w-lg lg:max-w-md xl:max-w-lg">
                    <div className="p-6 sm:p-8 md:p-10 lg:p-8 xl:p-10 bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-white/20">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout
